import { useContext, useState } from 'react';
import { CircularProgress } from '@mui/material';
import ModalContext from '../../../context/ModalContext';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { CloseRounded } from '@mui/icons-material';

import { updatePost } from '../../blogApi';

const PublishBlogModal = ({ modalDetails }) => {

  const modalCtx = useContext(ModalContext);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [blogDate, setBlogDate] = useState(() => {
    const existing = modalDetails?.blog?.publishedAt;
    return existing ? dayjs(existing) : dayjs();
  });
  const [error, setError] = useState(null);

  const handleCloseModal = () => {
    if (modalDetails.onClose) modalDetails.onClose();
    modalCtx.closeModal();
  };

  const handelDateChange = (date) => setBlogDate(date);

  const isDraft = modalDetails.blog.status === 'draft';

  /**
   * blog-api treats a future publishedAt as a scheduled post — it stays out of
   * the public listing until the date passes, with no cron involved. Going back
   * to draft leaves the date alone so re-publishing keeps the original.
   */
  const updateStatus = async () => {
    setUpdatingStatus(true);
    setError(null);

    try {
      await updatePost(modalDetails.blog.slug, isDraft
        ? { status: 'published', publishedAt: (blogDate ?? dayjs()).toISOString() }
        : { status: 'draft' });

      setUpdatingStatus(false);
      modalCtx.setPageUpdate({ page: 'Blogs' });
      modalCtx.closeModal();
    } catch (err) {
      console.error(err);
      setError(err.message);
      setUpdatingStatus(false);
    }
  }

  return (
    <div className="publish-blog-modal">
      <div className='heading'>
        <h3>Are you sure that you wish to {isDraft ? 'publish' : 'draft'} this blog ?</h3>
        <CloseRounded className='close' onClick={() => handleCloseModal()} />
      </div>

      {isDraft ? (
        <>
          <p>Choose Date</p>
          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker value={blogDate} onChange={handelDateChange} />
            </LocalizationProvider>
          </div>
        </>
      ) : null}

      {error ? <p style={{ color: '#d32f2f', fontSize: '0.85rem' }}>{error}</p> : null}

      <div className="footer">
        <button className="btn-primary-border" variant='outlined' onClick={() => handleCloseModal()}>Cancel</button>
        <button className="btn-primary" onClick={() => updateStatus()}>
          {updatingStatus ? <CircularProgress size={24} style={{ color: '#fff' }} /> : (isDraft ? 'Publish' : 'Draft')}
        </button>
      </div>
    </div>
  )
}

export default PublishBlogModal;
